<template>
  <div class="flex items-center gap-x-4 mb-2 tablet:flex-wrap">
    <p class="font-light text-1324 text-nowrap">
      {{ $t('soundAndVideo.allowMicAccess') }}
    </p>
    <wui-btn
      v-bind="micPermissionBtnProps"
      :variant="isMicrophonePermissionGranted ? 'positive' : 'neut'"
      state="tonal"
      :size="32"
      data-test="request-audio-permission"
      class="shrink-0"
      @click="onPermissionAudio()"
    >
      {{ textForAccessMicBtn }}
    </wui-btn>
  </div>
</template>

<script setup lang="ts">
import { WuiBtn, useRenderNotifier } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useStoreMediaDevices } from '@/entities/media-devices'

import { useLocalization } from '@/shared/composables/localization'
import { getMediaDevicesErrorMessage } from '@/shared/composables/media-stream'

const storeMediaDevices = useStoreMediaDevices()
const { isMicrophonePermissionGranted, microphoneAccessError } = storeToRefs(storeMediaDevices)
const { t } = useLocalization()
const { notifyError } = useRenderNotifier()

const micPermissionBtnProps = computed(() =>
  isMicrophonePermissionGranted.value ? { prependIcon: 'check' as const } : {},
)

const textForAccessMicBtn = computed(() => {
  return isMicrophonePermissionGranted.value ? t('soundAndVideo.accessIsAllowed') : t('common.request')
})

const onPermissionAudio = async () => {
  try {
    const granted = await storeMediaDevices.probeMicrophoneAccess()
    if (!granted) {
      notifyError(getMediaDevicesErrorMessage(microphoneAccessError.value, 'microphone'))
    }
  } catch (e: unknown) {
    notifyError(getMediaDevicesErrorMessage(e, 'microphone'))
  }
}
</script>

